import React from 'react'
import UploadStore from '../context/upload_file_context'
import FilesForm from '../antd/importers/FilesForm'
// import FilesForm from '../components/importers/FilesForm'

const ImportersApp = ({ }) => {
  return (
    <UploadStore>
      <FilesForm />
    </UploadStore>
  )
}

ImportersApp.propTypes = {
}

export default ImportersApp
